enum TimeCategory {
  EVENTS = 'events',
  CAMPAIGNS = 'campaigns',
  GENERAL = 'general',
  GIFTS = 'major',
  OPERATIONS = 'admin',
  GRANTS = 'foundations',
  GOVERNANCE = 'governance',
  ADVOCACY = 'advocacy',
  OTHER = 'other',
}

export default TimeCategory;
